$.ajaxSetup({
    dataType: 'JSON',
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }, beforeSend: function () {
        $.showLoader();
    }
});
